
// Count the number of new lines(paragraphs) of the content,
// and detect the new line character
export function countNewLines(content: string): { count: number; newLineCharacters: string } {
    let newLineCharacters = "";
    let returns = content.match(/(\r\n)/g) || []; // Windows
    if (returns.length > 0) {
        newLineCharacters = "\r\n";
    } else {
        returns = content.match(/\n/g) || []; // Unix/Mac OS X
        if (returns.length > 0) {
            newLineCharacters = "\n";
        } else {
            returns = content.match(/\r/g) || []; // Mac OS before X
            if (returns.length > 0) {
                newLineCharacters = "\r";
            }
        }
    }
    return { count: returns.length, newLineCharacters };
}
